<mat-dialog-content>
  @if (data.message_warning) {
    <div class="red-container text-center">
      {{ data.message }}
    </div>
  } @else {
    <div class="message">
      {{ data.message }}
    </div>
  }

  @if (data.copyText) {
    <div class="copy-box text-center">
      {{ formatCopyText(data.copyText) }}
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  @if (data.copyText) {
    <button mat-button type="button" (click)="copyToClipboard()">
      Copy
    </button>
  }

  <button mat-button cdkFocusInitial mat-dialog-close>
    Ok
  </button>
</mat-dialog-actions>